import { localContentPrefix } from '../../config';

import { showNotification } from '../notifications/actions';
import { AppDispatch } from '../index';
import i18n from '../../../i18n';
import { http } from '../../api/axios';

export const removeLocalContentCopies = (productId: string) => {
    return (dispatch: AppDispatch) => {
        return http
            .delete(`${localContentPrefix}/v1/localcollectioncontent/:productId/remove`, { pathParams: { productId } })
            .then(response => {
                dispatch(showNotification(i18n.t('notifications.removeLocalContentCopies.success')));
                return response.data;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    };
};
